// Libs
import React from 'react';
import { Grid } from '@mui/material';

// Components
import Track from '../../../../OrderHistory/Buttons/Track';
import ToggleButton from '../../../../Button/ToggleButton';

const OrderCardTrackingColumn = ({
  order,
  isDistro,
  isMobileMode,
  gridPropValues,
  classes,
  withChildren,
  onToggleChildren,
}) => (
  <Grid
    item
    flexBasis={gridPropValues({
      lgSize: 3,
      mdSize: 4,
      unit: '%',
    })}
    container
    pr={gridPropValues({
      lgSize: 2.5,
      mdSize: '10px',
    })}
    justifyContent="right"
    order={gridPropValues({
      lgSize: 4,
      mdSize: 2,
    })}>
    {order?.tracking_link && (
      <Track
        trackingLink={order.tracking_link}
        className={classes.trackButton}
      />
    )}
    {isDistro && (
      <>
        {isMobileMode && (
          <span className={classes.caption} data-testid="distro-label">
            Distro
          </span>
        )}
        {!!order?.children?.length && (
          <ToggleButton
            onToggle={onToggleChildren}
            open={withChildren}
            data-testid="distro-toggle-button"
          />
        )}
      </>
    )}
  </Grid>
);

export default OrderCardTrackingColumn;
